import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "uf-staff-selector__inner" }
const _hoisted_2 = {
  key: 1,
  class: "uf-staff-selector__inner-avatar2"
}
const _hoisted_3 = { class: "uf-staff-selector__info" }
const _hoisted_4 = { class: "uf-staff-selector__info-name" }
const _hoisted_5 = { class: "uf-staff-selector__info-other" }
const _hoisted_6 = { class: "uf-staff-selector__inner" }
const _hoisted_7 = {
  key: 1,
  class: "uf-staff-selector__inner-avatar2"
}
const _hoisted_8 = { class: "uf-staff-selector__info" }
const _hoisted_9 = { class: "uf-staff-selector__info-name" }
const _hoisted_10 = { class: "uf-staff-selector__info-other" }
const _hoisted_11 = { class: "uf-staff-selector__inner" }
const _hoisted_12 = {
  key: 1,
  class: "uf-staff-selector__inner-avatar2"
}
const _hoisted_13 = { class: "uf-staff-selector__info" }
const _hoisted_14 = { class: "uf-staff-selector__info-name" }
const _hoisted_15 = { class: "uf-staff-selector__info-other" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: _ctx.popupShow,
    "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.popupShow) = $event)),
    position: "right",
    style: { height: '100%', width: '100%' }
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_nav_bar, {
        title: "已选人员",
        "left-text": "返回",
        "left-arrow": "",
        onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupShow = false))
      }),
      _createVNode(_component_van_tabs, {
        active: _ctx.active,
        "onUpdate:active": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.active) = $event)),
        color: "#3d6eeb"
      }, {
        default: _withCtx(() => [
          (_ctx.data.copy_user_info.length)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 0,
                title: "员工",
                name: "staff"
              }))
            : _createCommentVNode("", true),
          (_ctx.data.stores_user_info.length)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 1,
                title: "客户",
                name: "customer"
              }))
            : _createCommentVNode("", true),
          (_ctx.data.factory_user_info.length)
            ? (_openBlock(), _createBlock(_component_van_tab, {
                key: 2,
                title: "供应商",
                name: "factory"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["active"]),
      _withDirectives(_createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.copy_user_info, (user) => {
          return (_openBlock(), _createElementBlock("div", {
            key: user.id,
            class: "uf-staff-selector__item"
          }, [
            _createElementVNode("div", _hoisted_1, [
              (user.head_pic)
                ? (_openBlock(), _createBlock(_component_van_image, {
                    key: 0,
                    round: "",
                    width: "40px",
                    height: "40px",
                    src: user.head_pic,
                    class: "uf-staff-selector__inner-avatar"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              (!user.head_pic)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(user.name[0]), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(user.name), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(user.from_name), 1)
              ])
            ])
          ]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.active === 'staff']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.stores_user_info, (user) => {
          return (_openBlock(), _createElementBlock("div", {
            key: user.id,
            class: "uf-staff-selector__item"
          }, [
            _createElementVNode("div", _hoisted_6, [
              (user.head_pic)
                ? (_openBlock(), _createBlock(_component_van_image, {
                    key: 0,
                    round: "",
                    width: "40px",
                    height: "40px",
                    src: user.head_pic,
                    class: "uf-staff-selector__inner-avatar"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              (!user.head_pic)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(user.name[0]), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(user.name), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(user.from_name), 1)
              ])
            ])
          ]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.active === 'customer']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.factory_user_info, (user) => {
          return (_openBlock(), _createElementBlock("div", {
            key: user.id,
            class: "uf-staff-selector__item"
          }, [
            _createElementVNode("div", _hoisted_11, [
              (user.head_pic)
                ? (_openBlock(), _createBlock(_component_van_image, {
                    key: 0,
                    round: "",
                    width: "40px",
                    height: "40px",
                    src: user.head_pic,
                    class: "uf-staff-selector__inner-avatar"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true),
              (!user.head_pic)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(user.name[0]), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(user.name), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(user.from_name), 1)
              ])
            ])
          ]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.active === 'factory']
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}